var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "c-radio-wrapper form-check",
      class: {
        "is-invalid": _vm.error,
        "border border-radio": _vm.bordered,
        checked: _setup.isChecked && _vm.bordered,
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _setup._model,
            expression: "_model",
          },
        ],
        staticClass: "form-check-input",
        attrs: { id: _setup.inputId, type: "radio", disabled: _vm.disabled },
        domProps: {
          value: _vm.inputValue,
          checked: _vm._q(_setup._model, _vm.inputValue),
        },
        on: {
          change: function ($event) {
            _setup._model = _vm.inputValue
          },
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "form-check-label", attrs: { for: _setup.inputId } },
        [
          !_setup.slots.default
            ? [_vm._v(" " + _vm._s(_vm.label) + " ")]
            : _vm._t("default"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }